export const LocalStorageKeys = {
  JWT_TOKEN: "teleport_admin_token",
  USER_DETAILS: "teleport_admin_data",
};
